import React, { ReactElement } from 'react';
import { Button, LoaderButton } from 'idsk-react-components';
import './urcenieGestoraButtons.scss';
import { BackButton, ConfirmModal } from 'slovlex-idsk-react-components';

interface Props {
  onClick: () => void;
  loading: boolean;
  isAdmin?: boolean;
}

const UrcenieGestoraButtons = ({
  onClick,
  loading,
  isAdmin = false,
}: Props): ReactElement => (
  <div className="gestor-determine-buttons__container">
    <ConfirmModal
      question="Naozaj si prajete uložiť novú konfiguráciu gestora a spolugestorov?"
      cancelButtonText="Nie"
      confirmButton={
          (
            <Button
              buttonStyle="action"
              size="large"
            >
              Áno
            </Button>
          )
        }
      openButton={(
        <LoaderButton
          loading={loading}
          size="large"
          disableOutsideClickWhileLoading
        >{isAdmin ? 'Zmeniť gestora a spolugestorov' : 'Uložiť'}
        </LoaderButton>
        )}
      doAfterConfirm={onClick}
    />
    <BackButton disabled={loading} />
  </div>
);
export default UrcenieGestoraButtons;
